import { render, staticRenderFns } from "./WindowResize.vue?vue&type=template&id=51c820dc"
import script from "./WindowResize.vue?vue&type=script&lang=js"
export * from "./WindowResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports